import React, {useMemo, useCallback} from "react";
import {useTranslation} from "react-i18next";
// local
import {subscriptionRoles} from "constants/auth.const";

export const MembersSummary = ({members, hideRoleCounter}) => {
  const {t} = useTranslation();

  const totalMembersCount = useMemo(() => members.length, [members]);

  const membersRoleCount = useCallback(
    (role) => members.filter((item) => item.SubscribeRoleId === role).length ?? 0,
    [members]
  );

  const RoleCount = ({role}) => (
    <React.Fragment>
      <span>{`${t(role)}:`}</span>
      <span className="fz-12 mr-4 ml-1">{membersRoleCount(role)}</span>
    </React.Fragment>
  );
  return (
    <span className="members__summary">
      <span className="black">{`${t("USER_ROLE_MEMBERS_SUMMARY_TOTAL")}:`}</span>
      <span className="black fz-12 mr-4 ml-1">{totalMembersCount}</span>
      {hideRoleCounter &&
        Object.values(subscriptionRoles).map((role, i) => (
          <RoleCount key={`${role}_${i}`} role={role} />
        ))}
    </span>
  );
};
